<template>
  <Card dis-hover :bordered="false">
    <div>
      <!-- 库存头部 -->
      <div class="warehouse_header">
        <div class="divs">
          <div class="fz18">仓库库存</div>
        </div>
      </div>

      <!-- 库存列表 -->
      <div class="warehouse_content">
        <div>
          <Button
            v-has="'WSS-3003-edit'"
            v-show="inventory"
            type="error"
            class="bt"
            @click="compilekc"
            >编辑</Button
          >
          <div v-show="preserve">
            <Button type="primary" class="bt" @click="preservekc">保存</Button>
            <Button class="bt ml20" @click="cancel">取消</Button>
          </div>
        </div>
        <!-- border="none" -->
        <p class="w22">同步时间较长，请在闲时进行操作！</p>
        <vxe-table
          border
          :loading="loading"
          ref="xTable"
          :data="tableData"
          align="left"
          :edit-rules="validRules"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :checkbox-config="{ checkStrictly: true, checkMethod }"
          @checkbox-change="selectChangeEvent"
          header-align="center"
          style="width: 720px"
        >
          <!-- <vxe-table-column title="仓库" type="checkbox">
            <template #default="{ row }">
              <vxe-checkbox type="checkbox">{{ row.name }}</vxe-checkbox>
            </template>
          </vxe-table-column> -->
           <!-- <vxe-table-column field="priority" title="优先级" :edit-render="{}">
            <template #edit="scope">
              <vxe-input
                :disabled="preserve == false"
                type="number"
                v-model="scope.row.priority"
                class="optimization"
                @change="$refs.xTable.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-table-column> -->
          <!-- <vxe-table-column width="60">
            <template v-slot>
              <span class="drag-btn" style="padding-left: 15px">
                <i class="vxe-icon--menu"></i>
              </span>
            </template>
            <template v-slot:header>
              <vxe-tooltip
                v-model="showHelpTip1"
                content="按住后可以上下拖动排序！"
                enterable
              >
                <i
                  class="vxe-icon--question"
                  @click="showHelpTip1 = !showHelpTip1"
                ></i>
              </vxe-tooltip>
            </template>
          </vxe-table-column> -->
          <vxe-table-column title="仓库名称" field="isCheck">
            <template v-slot="{ row, rowIndex }">
              <vxe-checkbox
                v-model="row.isCheck"
                :disabled="preserve == false"
                @change="isCheckChange(row, rowIndex)"
                >{{ row.name }}</vxe-checkbox
              >
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="priority"
            title="优先级"
            :edit-render="{ name: 'input' }"
          >
            <template v-slot="scope">
              <vxe-input
                :disabled="preserve == false"
                type="number"
                v-model="scope.row.priority"
                class="optimization"
                @change="$refs.xTable.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="priority" title="仓库所在地">
            <template #default="{ row }">
              <Select
                @on-change="changeSELECT"
                placeholder="请选择城市"
                :disabled="preserve == false"
                v-model="row.cityId"
                :label-in-value="true"
                filterable
                :transfer="true"
              >
                <Option v-for="item in list2" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </template>
          </vxe-table-column>
          <!-- <vxe-column field="statusName" title="状态">
             <template #default="{ row }">
              <span>{{ row.status ? '启用' : '禁用' }}</span>
            </template>
          </vxe-column> -->
        </vxe-table>
      </div>
    </div>
  </Card>
</template>

<script>
import {
  getcurtenant,
  editcurtenant,
  geinventoryt
} from '@/api/myweb/shopmanagement/storelist.js'
import VXETable from 'vxe-table'
import Sortable from 'sortablejs'
export default {
  data() {
    return {
      sortable1: {},
      showHelpTip1: false,
      data2: [],
      list2: [],
      value2: '',
      arr: [],
      arr1: [],
      loading: false, // 加载
      inventory: true,
      preserve: false,
      tableData: [], // 表单的数据
      validRules: {
        priority: [
          { required: true, message: '优先级必须填写' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能为正整数' }
        ]
      },
      disabled: false
    }
  },
  created() {
    this.getcurtenant()
    this.geinventoryt()
    this.rowDrop()
  },
  methods: {
    // 获取市
    async geinventoryt() {
      const res = await geinventoryt()
      console.log(res)
      if (res.status) {
        this.list2 = res.data
      }
    },
    isCheckChange(row, rowIndex) {
      this.tableData[rowIndex].isCheck = row.isCheck
      // console.log(checked,row,$event,'san')
    },
    async getcurtenant() {
      this.loading = true
      const res = await getcurtenant()
      if (res.status) {
        this.tableData = res.data.list
        this.tableData.forEach((item, index, arr) => {
          if (item.isCheck == 1) {
            this.$refs.xTable.setCheckboxRow([this.tableData[index]], true)
          }
          item.isCheck = item.isCheck == 0 ? false : true
        })
        this.loading = false
      }
    },
    // 编辑
    compilekc() {
      // console.log('编辑')
      this.inventory = false
      this.preserve = true
    },
    changeSELECT(val) {
      console.log(val)
      console.log(this.tableData)
      if (val) {
        // this.data2 = JSON.parse(JSON.stringify(this.tableData))
        this.tableData.forEach((item) => {
          if (item.cityId == val.value) {
            item.city = val.label
          }
        })
      }
    },
    // 保存
    async preservekc() {
      const $table = this.$refs.xTable
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      this.loading = true
      if (errMap) {
        VXETable.modal.message({ status: 'error', content: '校验不通过！' })
      } else {
        /*         let records = $table.getCheckboxRecords()
        records.map((item) => {
          item.isCheck = 1
        })
        this.arr = records
        let res = []
        res = this.tableData.filter((item) => {
          return !records.includes(item)
        })
        res.map((item) => {
          item.isCheck = 0
        })
        this.arr1 = res
        for (var i in this.arr) {
          this.arr1.push(this.arr[i])
        } */
        // console.log(this.arr1)
        // this.$Message.warning('仓库同步时间较长，请在闲时进行同步。');
        let arr = []
        this.tableData.map((el) => {
          let data = JSON.parse(JSON.stringify(el))
          data.isCheck = el.isCheck ? 1 : 0
          arr.push(data)
        })
        const data = await editcurtenant(arr)       
        if (data.status) {
          this.inventory = true
          // this.$Message.destroy()
          this.$Message.success('操作成功')
          this.getcurtenant()
          this.preserve = false
        }
      }

      this.loading = false
    },
    // 取消
    cancel() {
      this.inventory = true
      this.getcurtenant()
      this.preserve = false
    },
    // 选择
    selectChangeEvent({ checked, records }) {
      // records.map((item) => {
      //   item.isCheck = 1
      // })
      // this.arr = records
      // let res = []
      // res.push(
      //   this.tableData.filter((item) => {
      //     return !records.includes(item)
      //   })
      // )
      // this.arr1 = res
    },
    checkMethod({ row }) {
      return this.preserve == true
    },
    // 拖拽排序
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.xTable
        this.sortable1 = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              const currRow = this.tableData.splice(oldIndex, 1)[0]
              this.tableData.splice(newIndex, 0, currRow)
              console.log(this.tableData)
              // this.editParts(this.tableData)
            }
          }
        )
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import './warehouse.less';
.my-dropdown2 {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
}
</style>
